import { useCallback } from 'react'

import { AppTemplate } from 'features/templates/types'

import { FileUploadModal } from 'ui/components/FileUpload'
import { useGlobalModal } from 'ui/components/Modal/useGlobalModal'

type UseAppTemplateDetailScreenshotStateOptions = {
    template: AppTemplate
    onChange?: (template: Partial<AppTemplate>) => void
    isEditable?: boolean
}

export function useAppTemplateDetailScreenshotState({
    template,
    onChange,
    isEditable,
}: UseAppTemplateDetailScreenshotStateOptions) {
    const screenshotUrl = template.screenshot_urls?.[0]
    const showThumbnail = (isEditable && !!screenshotUrl) || !isEditable

    const { show } = useGlobalModal(FileUploadModal)
    const onUploadClick = useCallback(() => {
        show({
            maxFiles: 1,
            zIndex: 9999,
            accept: 'image/*',
            onUploadSuccess: (files) => {
                const file = files[0]
                if (!file) return

                const src = file.url ?? ''
                onChange?.({ screenshot_urls: [src] })
            },
        })
    }, [show, onChange])

    const onRemoveScreenshot = useCallback(() => {
        onChange?.({ screenshot_urls: undefined })
    }, [onChange])

    const thumbnailUrl = template.thumbnail_url || ''

    const onChangeThumbnail = useCallback(
        (url: string) => {
            const newValue = !!url ? url : undefined
            onChange?.({ thumbnail_url: newValue })
        },
        [onChange]
    )

    return {
        screenshotUrl,
        onUploadClick,
        showThumbnail,
        onRemoveScreenshot,
        thumbnailUrl,
        onChangeThumbnail,
    }
}
